const jwt = require('jsonwebtoken')

const SECRET_KEY = '2025_majuon_jwt_key'

/*
export interface JwtModule extends jwt.JwtPayload {
  type: string //'SEARCH_SUBMIT_SUCCESS',
  message: string // msg || '', // 검색어
  name: string // userRef.current.name, // 사용자 이름
  userType: string // userRef.current.userType, // 사용자 타입 => [학생: student, 선생님: teacher, 학부모: parent, 교직원: employee]
  school: string // userRef.current.school, // 학교 이름
  buttonType: string // buttonType || '',
  accessToken: string | undefined // cookies.get('MAJUON_ACCESS_TOKEN'), // accessToken
}
  */

export const createJwtToken = (data) => {
  let token = jwt.sign(data, SECRET_KEY, {
    expiresIn: '1h', // 토큰 유효 기간 설정
  })

  return token
}
